import type { ResourceTypeHandle } from '@toolproof-core/genesis/_contract/_index';
import { coreProjection } from '@toolproof-core/genesis/_data/metadata/core';
import { yellowpapers } from '@toolproof-core/genesis/_data/metadata/yellowpapers';

import type { SpaceAdapterResourceTypeInputSpec } from '@toolproof-core/visualization/adapter/_contract/adapter';

import { RESOURCE_TYPE_REQUIREMENTS, TYPE_CORE_TREE } from '@/adapters/core/_data/config/fragments/resourceTypes';
import type { CoreTreeResource } from '@/adapters/core/_contract/config';
import { assertCoreYellowpapers } from '@/_pure/yellowpaperValidation';

const CORE_TREE_RESOURCE = {
    id: 'RESOURCE-CORE_TREE',
    resourceTypeHandle: TYPE_CORE_TREE,
    provenance: { provenanceKind: 'genesis' },
    projection: coreProjection,
} satisfies CoreTreeResource;

export const RESOURCE_TYPE_INPUT_SPEC = {
    requiredResourceTypes: RESOURCE_TYPE_REQUIREMENTS,
    presetResourcesByType: {
        [TYPE_CORE_TREE]: [CORE_TREE_RESOURCE],
    },
} as const satisfies SpaceAdapterResourceTypeInputSpec<ResourceTypeHandle>;

export function getResourceTypeInputSpec() {
    assertCoreYellowpapers(coreProjection, yellowpapers);
    return RESOURCE_TYPE_INPUT_SPEC;
}
